<template>
	<section>
        <div class="row">
            <div class="qualifier-tool-status-bar">
                <div class="qualifier-tool-status-number qualifier-tool-status-number-active">1</div>
                <div class="qualifier-tool-status-number qualifier-tool-status-number-active">2</div>
                <div class="qualifier-tool-status-number">3</div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <h3>{{model.Step4bTitle}}</h3>
                <p class="qualifier-tool-subheader">{{model.Step4bSubTitle}}</p>
            </div>
        </div>
        <form @submit.prevent="nextStepValidation">
            <div class="row qualifier-tool-form-row">
                <div class="col-12 d-block d-md-flex justify-content-center qualifier-tool-form-row-container">
                    <div class="qualifier-tool-form-group-alt">
                        <div class="qualifier-tool-question-input-container" :class="{valid: fields.FirstName && fields.FirstName.valid, active: firstName}">
                            <input v-validate="'required'" name="FirstName" type="text" class="qualifier-tool-question-input" id="Firstname" v-model="firstName">
                            <label for="Firstname"><span>{{model.Step4FirstName}}</span></label>
                            <span v-if="vErrors.first('FirstName')">{{model.RequiredMessage}}</span>
                        </div>
                    </div>
                    <div class="qualifier-tool-form-group-alt">
                        <div class="qualifier-tool-question-input-container" :class="{valid: fields.LastName && fields.LastName.valid, active: lastName}">
                            <input v-validate="'required'" name="LastName" type="text" class="qualifier-tool-question-input" id="Lastname" v-model="lastName">
                            <label for="Lastname"><span>{{model.Step4LastName}}</span></label>
                            <span v-if="vErrors.first('LastName')">{{model.RequiredMessage}}</span>
                        </div>                
                    </div>
                    <div class="qualifier-tool-form-group-alt">
                        <div class="qualifier-tool-question-input-container" :class="{valid: emailValid && fields.Email.valid, active: email, invalid: vErrors.first('Phone') && phoneLengthError}">
                            <input v-validate="'required|email'" ref="Email" name="Email" type="text" class="qualifier-tool-question-input" id="Email" v-model="email" @blur="emailValid = email">
                            <label for="Email"><span>{{model.Step4Email}}</span></label>
                            <span v-if="vErrors.first('Email')">{{vErrors.first('Email')}}</span>
                        </div>
                        <div class="qualifier-tool-question-input-container" v-if="email" :class="{valid: fields.ConfirmEmail && fields.ConfirmEmail.valid, active: confirmEmail}">
                            <input v-validate="'required|email|confirmed:Email'" name="ConfirmEmail" type="text" class="qualifier-tool-question-input" id="ConfirmEmail" v-model="confirmEmail">
                            <label for="ConfirmEmail"><span>{{model.Step4ConfirmEmail}}</span></label>
                            <span v-if="vErrors.has('ConfirmEmail')">{{ vErrors.first('ConfirmEmail') }}</span>
                        </div>

                        
                    </div>
                    <div class="qualifier-tool-form-group-alt">
                        <div class="qualifier-tool-question-input-container" :class="{valid: fields.Phone && fields.Phone.valid, invalid: vErrors.first('Phone') && phoneLengthError, active: phone}">
                            <input v-validate="'required|min:10|max:10'" ref="Phone" name="Phone" type="text" class="qualifier-tool-question-input" id="Phone" @blur="handlePhoneLength" v-model="phone" onkeydown="return ( event.ctrlKey || event.altKey || (47<event.keyCode && event.keyCode<58 && event.shiftKey==false) || (95<event.keyCode && event.keyCode<106)|| (event.keyCode==8) || (event.keyCode==9) || (event.keyCode>34 && event.keyCode<40) || (event.keyCode==46) || (event.keyCode==48) && event.keyCode != 32 && !(event.keyCode == 57 && event.shiftKey) && !(event.keyCode == 48 && event.shiftKey))" @paste="handleOnPaste($event, false)">
                            <label for="Phone"><span>{{model.Step4Phone}}</span></label>
                            <span v-if="vErrors.first('Phone')">{{ vErrors.first('Phone') }}</span>
                        </div>    

                        <div class="qualifier-tool-question-input-container" v-if="phone" :class="{valid: fields.ConfirmPhone && fields.ConfirmPhone.valid, active: confirmPhone}">
                            <input v-validate="'required|min:10|max:10|confirmed:Phone'" name="ConfirmPhone" type="text" class="qualifier-tool-question-input" id="ConfirmPhone" v-model="confirmPhone" onkeydown="return ( event.ctrlKey || event.altKey || (47<event.keyCode && event.keyCode<58 && event.shiftKey==false) || (95<event.keyCode && event.keyCode<106)|| (event.keyCode==8) || (event.keyCode==9) || (event.keyCode>34 && event.keyCode<40) || (event.keyCode==46)  || (event.keyCode==48) && event.keyCode != 32 && !(event.keyCode == 57 && event.shiftKey) && !(event.keyCode == 48 && event.shiftKey))" @paste="handleOnPaste($event, true)">
                            <label for="ConfirmPhone"><span>{{model.Step4ConfirmPhone}}</span></label>
                             <span v-if="vErrors.first('ConfirmPhone')">{{ vErrors.first('ConfirmPhone') }}</span>
                        </div>            
                    </div>
                </div>
            </div>

            <div class="row qualifier-tool-form-row">
                <div class="col-12 d-block d-md-flex justify-content-center qualifier-tool-form-row-container spaced-row">
                    <div class="qualifier-tool-form-group-alt">
                        <div class="qualifier-tool-question-input-container" :class="{valid: fields.SeniorFirstName && fields.SeniorFirstName.valid, active: seniorFirstName}">
                            <input v-validate="'required'" name="SeniorFirstName" type="text" class="qualifier-tool-question-input" id="SeniorFirstName" v-model="seniorFirstName">
                            <label for="SeniorFirstName"><span>{{model.Step4SeniorFirstName}}</span></label>
                            <span v-if="vErrors.first('SeniorFirstName')">{{model.RequiredMessage}}</span>
                        </div>
                    </div>
                    <div class="qualifier-tool-form-group-alt">
                        <div class="qualifier-tool-question-input-container" :class="{valid: fields.SeniorLastName && fields.SeniorLastName.valid, active: seniorLastName}">
                            <input v-validate="'required'" name="SeniorLastName" type="text" class="qualifier-tool-question-input" id="SeniorLastName" v-model="seniorLastName">
                            <label for="SeniorLastName"><span>{{model.Step4SeniorLastName}}</span></label>
                            <span v-if="vErrors.first('SeniorLastName')">{{model.RequiredMessage}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row d-flex justify-content-center qualifier-tool-footer">
                <button type="submit" class="qualifier-tool-btn" v-bind:disabled="disableSubmit">{{model.SubmitButtonText}}*</button>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="qualifier-tool-footer-text" v-html="model.Step4FooterText"></div>
                </div>
            </div>       
        </form>
	</section>
</template>

<script>
	import SmoothScroll from 'smooth-scroll';
	import { mapState, mapActions, mapMutations } from 'vuex';

	export default {
		props: ['model'],
		data: function () {
			return {
                firstName: "",
                lastName: "",
                seniorFirstName: "",
                seniorLastName: "",
                email: "",
                emailValid: "",
                confirmEmail: "",
                phone: "",
                confirmPhone: "",
                NewsletterSignup: true,
                disableSubmit: false,
                active: false,
                CampaingId: this.model.CampaingId,
                phoneLengthError: false,
                unsubscribe: null
			}
		},
		computed: mapState({
            concurrentGuid: state => state.WebQualifierTool.concurrentGuid,
            formData: state => state.WebQualifierTool.formData,
		}),
		components: {
		},
		mounted: function () {
            let _this = this;
            
            this.unsubscribe = this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'WebQualifierTool/setQTResponse') {
                    if(state.WebQualifierTool.qtResponse && state.WebQualifierTool.qtResponse.IsDuplicate){
                        _this.updateStep(15); 
                    }else{
                        _this.updateStep(11);  
                        this.disableSubmit = false;              
                    }
				}
                if (mutation.type === 'WebQualifierTool/setQTErrorResponse') {
                    _this.disableSubmit = false;
                }
			});		
            if (window.dataLayer != null) {
                window.dataLayer.push({'event': 'Step4B'});    
            }
		},
        beforeDestroy: function () {
            if (this.unsubscribe) {
                this.unsubscribe();
            }
        },
		methods: {
            ...mapActions('WebQualifierTool', { updateStep: 'updateStep' }),
            ...mapActions('WebQualifierTool', { postData: 'postData' }),
            ...mapMutations('WebQualifierTool', { setLoadingState: 'setLoadingState' }),
            handlePhoneLength() {
                this.phone.length > 10 ? this.phoneLengthError = true : this.phoneLengthError = false;
            },
            nextStepValidation() {
                this.$validator.validate().then(valid => {
                    if (!valid) {
                        //Do nothing
                        return;
                    }
                    this.postPersonalInfo();
                });
            },
            handleOnPaste(e, isConfirmPhone = false) {
                e.preventDefault();
                let pastedData = e.clipboardData.getData('text').replace(/\s+/g, '');
                if (/^\d+$/.test(pastedData)) {
                    if (!isConfirmPhone) 
                        this.phone = pastedData;     
                    else 
                        this.confirmPhone = pastedData;
                }                
            },
            postPersonalInfo() {
                let data = {
                    "SubmitToWebService": true,
                    "IsNewRequest": false,
                    "SetKenticoContact": true,
                    "SubmittedQualifierToolGuid": this.concurrentGuid,
                    "QualifierToolToSubmitModel": {
                        "ivg_campaignidtext" : this.CampaingId,
                        "FirstName": this.firstName,
                        "LastName": this.lastName,
                        "LovedOneFirstName": this.seniorFirstName,
                        "LovedOneLastName": this.seniorLastName,
                        "Email": this.email,
                        "Phone": this.phone,
                        "ForLovedOne": true,
                        "SubscribeToNewsletter": this.NewsletterSignup,
                        "SubmissionDate": new Date(),
                        "ContactFormSyncDate": new Date(),
                        "FormPageURL": window.location.href.split('?')[0],
                        "ReferringUTMQueryString": this.formData.utmData,
                        "FormStep": "step4b",
                    }
                }
                this.disableSubmit = true;
                this.setLoadingState(true);
                this.postData(data);
                if (window.dataLayer != null) {
                    window.dataLayer.push({'event': 'Step4B.FormSubmission'});    
                }
            }
        },
    }
</script>
